import PortableText from "@sanity/block-content-to-react";
import clsx from "clsx";
import React from "react";
import { dataset, projectId } from "~/sanity";

export interface PortableTextProps {
  blocks: object;
  style?: object;
  textStyle?: object;
}

function BlockTypeSerializer(props: any) {
  const style = props.node.style || "normal";

  // If children are empty, don't render anything
  if (!props.children) return null;

  if (/^h\d/.test(style)) {
    return heading({
      children: props.children,
      variant: style,
    });
  }

  return (
    <p
      className={clsx([
        "mt-5 font-apercu text-xl text-text-gray",
        "md:px-2 md:text-2xl md:leading-loose",
      ])}
      style={props.textStyle}
    >
      {props.children}
    </p>
  );
}

// const image = (props: any) => {
//   const padding = 24;
//   const { width: screenWidth } = useWindowDimensions();

//   const asset = useMemo(() => {
//     if (!props?.node?.asset) return "";
//     return props.node.asset;
//   }, [screenWidth]);

//   const isSvg = asset.includes(".svg");
//   const isImage =
//     asset.includes(".png") || asset.includes(".jpg") || asset.includes(".jpeg");

//   if (asset && isSvg) {
//     return (
//       <View
//         style={{
//           width: screenWidth - padding * 2,
//           height: screenWidth - padding * 2,
//         }}
//       >
//         <RemoteSVG
//           uri={asset}
//           width={screenWidth - padding * 2}
//           height={screenWidth - padding * 2}
//         />
//       </View>
//     );
//   }

//   if (asset && isImage) {
//     const resized = resizeImage(asset, screenWidth);

//     return (
//       <View>
//         <FastImage
//           source={{ uri: resized as string }}
//           style={{
//             width: screenWidth - padding * 2,
//             height: screenWidth - padding * 2,
//           }}
//         />
//       </View>
//     );
//   }

//   return null;
// };

const strong = (props: any) => {
  return <strong className="font-bold">{props.children}</strong>;
};

const italic = (props: any) => {
  return <i>{props.children}</i>;
};

const underlined = (props: any) => {
  return <u>{props.children}</u>;
};

const strikeThrough = (props: any) => {
  return <s>{props.children}</s>;
};

const rule = () => {
  return <div />;
};

const heading = (props: {
  children: any;
  variant: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}) => {
  const { variant, children } = props;

  return React.createElement(
    variant,
    {
      className: clsx([
        variant === "h1" && "mb-8 font-logo text-4xl",
        variant === "h2" && "mt-10 font-logo text-3xl",
        variant === "h3" && "mt-8 font-logo text-2xl",
      ]),
    },
    children
  );
};

export const pageMap = {
  article: "Article",
};

const link = (props: any) => (
  <a
    href={props.mark.href}
    className="text-blue-primary underline hover:text-blue-hover"
  >
    {props.children}
  </a>
);

const ZestPortableText = ({ blocks, style, textStyle }: PortableTextProps) => {
  if (!blocks) {
    return null;
  }

  return (
    <div style={style}>
      <PortableText
        projectId={projectId}
        dataset={dataset}
        blocks={blocks}
        serializers={{
          marks: {
            strong: (props: any) => strong(props),
            em: (props: any) => italic(props),
            link: (props: any) => link(props),
            underline: (props: any) => underlined(props),
            "strike-through": (props: any) => strikeThrough(props),
          },
          types: {
            block: (props: any) => {
              return (
                <BlockTypeSerializer
                  blocks={blocks}
                  style={style}
                  textStyle={textStyle}
                  {...props}
                />
              );
            },
            // image: (props: any) => image(props),
            break: rule,
          },
        }}
      />
    </div>
  );
};

export default ZestPortableText;
